import type { Bcp47Locale } from '@backmarket/http-api'

export default function createDateFormatter(locale: Bcp47Locale) {
  return (date: Date, options?: Intl.DateTimeFormatOptions) =>
    Intl.DateTimeFormat(locale, options).format(date)
}
